import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { BusAuctionFilterService } from '../../../services/bus-auction-filter.service';
import { AuctionDetailService } from '../../../services/home-auction-detail.service';
import { finalize, timeout } from 'rxjs/operators';
import { LoggingService } from '../../../../../services/logging.service';


const apiServer = environment.apiServer;
declare var $: any;

@Component({
  selector: 'app-modal-send-adjustment',
  templateUrl: './modal-send-adjustment.component.html',
  styleUrls: ['./modal-send-adjustment.component.sass']
})



export class ModalSendAdjustmentComponent implements OnInit {
  spinner: NgxSpinnerService;
  http: HttpClient;
  bus: BusAuctionFilterService;
  service: AuctionDetailService;
  params: any;
  mail = { IDAuc: undefined, AucAgreementComment: undefined };


  constructor(private _http: HttpClient, private _spinner: NgxSpinnerService, private _bus: BusAuctionFilterService, private _service: AuctionDetailService, private loggingService: LoggingService) {
    this.http = _http;
    this.spinner = _spinner;
    this.bus = _bus;
    this.service = _service;
  }

  ngOnInit() {


    $('#modalAdjustmentSender').on('show.bs.modal', function () {
      $('#modalAuctionDetail').css({ 'z-index': 1030 });
    })

    $('#modalAdjustmentSender').on('hidden.bs.modal', function () {
      $('#modalAuctionDetail').css({ 'z-index': 1041 });
    })
  }

  cleannField() {
    this.mail.AucAgreementComment = undefined;
  }

  saving = false;

  onSave() {
    const _xid = this.loggingService.generateUUID();
    
    if (this.saving) return;
    this.saving = true;
    this.spinner.show();

    this.loggingService.logStart(_xid, 'App.Components.ModalSendAdjustmentComponent.onSave', null, 'Save started');

    this.service.saveAuction(this.bus.currentAuction).pipe(
      finalize(() => {
        this.saving = false;
        this.spinner.hide();
      })
    ).subscribe({
      next: () => {
        this.mail.IDAuc = this.bus.currentAuction.code;
        this.http.post<boolean>(apiServer + "/SendMailToConfirm/", this.mail).subscribe(resp => { });

        this.bus.changeAuctionNumber(this.bus.currentAuction.code);

        $('#modalAdjustmentSender').modal('toggle');
        $('#modalAuctionDetail').modal('toggle');
        this.loggingService.logFinish(_xid, 'App.Components.ModalSendAdjustmentComponent.onSave', null, 'Save completed');
      },
      error: err => {
        console.log(err)
        this.loggingService.logError(_xid, 'App.Components.ModalSendAdjustmentComponent.onSave', err, null, 'Save failed');
      }
    });
  }


}




// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-detail/modal-send-adjustment/modal-send-adjustment.component.ts